import { DayOfWeek } from "schema-dts"

export const GOOGLE_ANALYTICS_ID = "G-BS5BLHN0X5"

export const PHONE_NUMBER = "040 33466702"
export const CONTACT_EMAIL = "contact@artivo-gallery.com"
export const COMPANY_LEGAL_NAME = "Artelio UG (haftungsbeschränkt)"
export const BRAND_NAME = "Artivo"
export const GOOGLE_WEBSITENAME = BRAND_NAME.toUpperCase()
export const ALTERNATE_WEBSITE_NAMES = ["Artivo Gallery", "Artivo Galerie", "Artivo Kunstgalerie", "Artivo art gallery"]
export const INSTAGRAM_PROFILE_URL = "https://instagram.com/artivo.gallery"

// Maximum number of dynamic pages that are pre generated at build time e.g. artworks, artists
export const MAX_STATIC_PAGE_GENERATION = 10000

export const TIMEZONE = "Europe/Berlin"
export const CUSTOMER_SERVICE_OPENING_HOUR = "09:00"
export const CUSTOMER_SERVICE_CLOSING_HOUR = "18:00"
export const CUSTOMER_SERVICE_OPENING_DAYS: DayOfWeek[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] as const
export const COMPANY_FOUNDING_DATE = "2023-07-06"
export const UST_ID = ""
export const AREA = "EU"
export const COMPANY_LOGO = "/logo_512x512.png"
